module.exports = __webpack_public_path__ + "img/18_windAndRain_zjy.aff064a8.png";